
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import MainTesla from "../components/MainTesla";
import PopUp from "../components/PopUpCTA";

import { Helmet } from "react-helmet-async";

const Tesla = () => {
    return (
        <div>
            <Helmet>
                <title>Tesla Body Shop Approved - Carrozzeria Bulletti</title>
            </Helmet>
            <Navbar />
            <MainTesla />
            <PopUp />
            <Footer />
        </div>
    );
  };

  export default Tesla;
